import { render, staticRenderFns } from "./BlockVisibilitySwitch.vue?vue&type=template&id=80a29dc4&scoped=true"
import script from "./BlockVisibilitySwitch.vue?vue&type=script&lang=js"
export * from "./BlockVisibilitySwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a29dc4",
  null
  
)

export default component.exports